import React from "react";
import { TrialBalanceResponse } from "@common/types/reports/types";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { Card } from "@design-system/Card/Card";
import { CardSection } from "@design-system/Card/CardSection";
import { GlTableCallbacks } from "../glDrillDown.lib";
import { AccountingReportFilters } from "../types";
import {
    AccountingReportContext,
    useAccountingReportContextValue,
} from "../AccountingReport.context";
import { AccountingReportHeader } from "../AccountingReportHeader";
import { AccountingReportFooter } from "../AccountingReportFooter";
import { useReportChrome } from "../useReportChrome";
import { TrialBalanceTable } from "./TrialBalanceTable";
import styles from "./TrialBalanceTable.module.scss";

interface Props {
    data: TrialBalanceResponse;
    filters: AccountingReportFilters;
    chrome: ReportPresentationChrome;
    numberFormat: NumberFormatValues;
    generationDate: Date;
    onDrillDown: GlTableCallbacks["onDrillDown"];
}

export const TrialBalancePageContent: React.FC<Props> = ({
    data,
    filters,
    chrome,
    numberFormat,
    generationDate,
    onDrillDown,
}) => {
    const resolvedChrome = useReportChrome({
        chrome,
        generationDate,
    });

    const accountingReportContext = useAccountingReportContextValue(
        filters,
        numberFormat,
    );

    return (
        <Card stacked sharpEdges fullPage>
            <AccountingReportContext.Provider value={accountingReportContext}>
                <CardSection className={styles.header}>
                    <AccountingReportHeader chrome={resolvedChrome} />
                </CardSection>
                <TrialBalanceTable data={data} onDrillDown={onDrillDown} />
                <AccountingReportFooter chrome={resolvedChrome} />
            </AccountingReportContext.Provider>
        </Card>
    );
};
